import type { FleetCompanyContract } from '../../__generated__/graphql';
import type { MultipleContractDto } from '../businessManager/APITypes';

/** Formato legado da área do cliente, derivado da mesma query GraphQL `contracts(fleetId)`. */
export const toMultipleContractDto = (contracts: FleetCompanyContract[] | null | undefined): MultipleContractDto => {
  if (!contracts || contracts.length === 0) {
    return { status: true, data: [], hasData: false };
  }

  // Os campos opcionais chegam como `null`, apesar do tipo legado declarar `string`.
  const mappedData = contracts.map((contract) => ({
    companyId: String(contract.companyId || ''),
    razao_social: contract.corporateName || '',
    cnpj: contract.cnpj || '',
    date_contract: contract.contractSignedDate || '',
    address: contract.address || null,
    phone: contract.phone || null,
    sector: contract.industry || null,
    responsible: contract.responsavel || null,
    last_changed_form: contract.lastRegistrationChangeDate || '',
    mrr_moeda: contract.mrrCurrency || null,
    dia_faturamento: contract.billingDay || null,
    dia_pro_rata: null,
    dia_vencimento: contract.dueDay || null,
    metodo_pagamento: contract.paymentMethod || null,
    frequencia_pagamento: contract.paymentFrequency || null,
    indice_reajuste: contract.financialAdjustmentIndex || null,
    recent_deal_product: contract.recentConversionEventName || '',
    bloqueio_upsell_area_logada: contract.upsellBlockLoggedArea || null,
  })) as unknown as MultipleContractDto['data'];

  return {
    status: true,
    data: mappedData,
    hasData: mappedData.length > 0,
  };
};
